import "./style.scss";

import { Info } from "assets/img/svg/info";

interface IInfoBlue {
    /**
     * (Optional) Will replace the default icon
     */
    icon?: React.ReactNode;
    /**
     * Information to display
     */
    info: React.ReactNode;
    svgWidth?: string;
    svgHeight?: string;
    /**
     * Whether to hide the icon or not.
     */
    hideIcon?: boolean;
    textStyle?: React.CSSProperties;
}

/**
 * Blue block to display message.
 */
const InfoBlockBlue = ({ icon, info, svgWidth = "16px", svgHeight = "16px", hideIcon, textStyle }: IInfoBlue) => {
    const defaultIcon = <Info width={svgWidth} height={svgHeight} color="#275AB0" />;

    return (
        <div className="info-container">
            {!hideIcon && (icon ? icon : defaultIcon)}
            <span style={textStyle}>{info}</span>
        </div>
    );
};

export default InfoBlockBlue;
